module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_L4-7af7427a649e820cd24c518e1ec74eac.png";